import { render } from "./AboutSectionComponent.vue?vue&type=template&id=71734cd6&ts=true"
import script from "./AboutSectionComponent.vue?vue&type=script&lang=ts"
export * from "./AboutSectionComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__